import { IStreamsFilterStore } from './streamsFilter.interface';

export const streamsFilterInitialState: IStreamsFilterStore = {};
